import {UI} from "../../../../../../stem-core/ui/UIBase";
import {styleRule, StyleSheet} from "../../../../../../stem-core/ui/Style";
import {registerStyle} from "../../../../../../stem-core/ui/style/Theme";
import {Messages} from "../../../../../Messages";
import {PaymentMethodDescription} from "../../../../../common/PaymentMethodDescription.jsx";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";
import {Flow} from "../../../../flows/Flow.js";


class PaymentMethodAcceptOrChangeStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        justifyContent: "space-between",
    };
}

// Component that shows the currently selected payment method or allows you to enter a flow to change/add another
@registerStyle(PaymentMethodAcceptOrChangeStyle)
export class PaymentMethodAcceptOrChange extends UI.Element {
    isValid() {
        return true;
    }

    getPaymentMethod() {
        return Flow.paymentMethod.selectedValue;
    }

    render() {
        return [
            <PaymentMethodDescription paymentMethod={this.getPaymentMethod()}/>,
            <LinkButton
                label={Messages.change}
                onClick={() => Flow.paymentMethod.prompt({inlineSubflow: true, continueLabel: Messages.continue})}
            />,
        ]
    }
}
